/**
 * ContractorRoute — wraps all contractor-facing /v4/* screens.
 *
 * Allows: user_role === null / 'contractor' / 'gc'
 * Blocks: vendors/subs → redirect to /vendor/dashboard
 * Loading: renders spinner while auth resolves
 */

import { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth, isVendor } from '../../context/AuthContext'

interface ContractorRouteProps {
  children: ReactNode
}

export default function ContractorRoute({ children }: ContractorRouteProps) {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        background: 'var(--bg)',
      }}>
        <div className="auth-spinner" />
      </div>
    )
  }

  if (!user) {
    const next = encodeURIComponent(`${location.pathname}${location.search}`)
    return <Navigate to={`/login?next=${next}`} replace />
  }

  if (isVendor(user)) {
    return <Navigate to="/vendor/dashboard" replace />
  }

  return <>{children}</>
}
